import { action, computed, makeAutoObservable } from 'mobx'
import { Store } from '@stores'

export class FailedJobsStore {
  _store: Store
  loading: boolean
  failed_job: any | null
  retrying_failed_job: boolean

  constructor(store: Store) {
    makeAutoObservable(this)
    this._store = store
    this.loading = false
    this.failed_job = null
    this.retrying_failed_job = false
  }

  @computed
  get is_loading() {
    return this.loading
  }

  @computed
  get watch_failed_job() {
    return this.failed_job
  }

  @computed
  get is_retrying_failed_job() {
    return this.retrying_failed_job
  }

  @action
  async getFailedJob(id: string | number) {
    this.loading = true
    this.failed_job = null
    try {
      const res = await this._store.api.jobs.get_failed_job_single(id)
      this.failed_job = res
      return res
    } finally {
      this.loading = false
    }
  }

  @action
  async retryFailedJob(id: string | number) {
    this.retrying_failed_job = true
    try {
      const res = await this._store.api.jobs.retry_failed_job(id)
      return res
    } finally {
      this.retrying_failed_job = false
    }
  }
}
